import { confirmAsync } from '../../utils/confirm';
import { useState, useMemo, useEffect, useCallback } from 'react';
import DatePicker from '../../components/DatePicker';
import UsageInfo from '../../components/UsageInfo';
import { getPersonelGider, addPersonelGider, updatePersonelGider, deletePersonelGider } from '../../services/api';
import { useKasa } from '../../context/KasaContext';
import LoadingSpinner from '../../components/LoadingSpinner';
import EmptyState from '../../components/EmptyState';
import PageHeader from '../../components/PageHeader';
import { downloadExcel, printTable } from '../../utils/exportUtils';
import ModalShell from '../../components/ModalShell';

// ── Yardımcılar ───────────────────────────────────────────────────────────
function pad(n) { return String(n).padStart(2, '0'); }
function bugunStr() { var d = new Date(); return pad(d.getDate()) + '.' + pad(d.getMonth() + 1) + '.' + d.getFullYear(); }
function ayBas() { var d = new Date(); return '01.' + pad(d.getMonth() + 1) + '.' + d.getFullYear(); }
function ddmmyyyyToIso(s) {
  if (!s) return '';
  var p = s.split('.');
  if (p.length < 3) return '';
  return p[2] + '-' + p[1] + '-' + p[0];
}
function ddmmyyyyToDate(s) {
  if (!s) return null;
  var p = s.split('.');
  if (p.length < 3) return null;
  return new Date(Number(p[2]), Number(p[1]) - 1, Number(p[0]));
}
function clampBitis(bas, bit) {
  var db = ddmmyyyyToDate(bas), de = ddmmyyyyToDate(bit);
  if (db && de && db > de) return bas;
  return bit;
}

// ── Gider Modal ───────────────────────────────────────────────────────────
function GiderModal({ kayit, personelListe, giderGruplari, odemeTipListesi, paraBirimiListesi, bankaListesi, dovizKurlari, onKaydet, onSil, onKapat, saving }) {
  var duzenleme = !!kayit?.kasaGiderId;
  var [personelHedefId, setPersonelHedefId] = useState(kayit?.personelHedefId || '');
  var [giderGrubuId,    setGiderGrubuId]    = useState(kayit?.giderGrubuId || '');
  var [ad,         setAd]         = useState(kayit?.aciklama || '');
  var [tutar,      setTutar]      = useState(kayit?.birimTutar || 0);
  var [paraBirimi, setParaBirimi] = useState(kayit?.paraBirimi || paraBirimiListesi.find(p => p === 'TRY' || p === 'TL') || paraBirimiListesi[0] || 'TL');
  var [miktar,     setMiktar]     = useState(kayit?.miktar || 1);
  var [odemeTip,   setOdemeTip]   = useState(kayit?.odemeTipi || (odemeTipListesi[0] || 'BANKA HAVALE'));
  var [banka,      setBanka]      = useState(kayit?.bankaAdi || 'QNB');
  var [tarih,      setTarih]      = useState(kayit?.tarih || bugunStr());
  var [saat,       setSaat]       = useState(kayit?.saat || '09:00');
  var toplam = (parseFloat(tutar) || 0) * (parseFloat(miktar) || 1);
  var kurDegeri = (dovizKurlari && dovizKurlari[paraBirimi]) ? dovizKurlari[paraBirimi] : 1;
  var tlKarsıligi = toplam * kurDegeri;

  var INP = 'w-full bg-gray-50 border-2 border-transparent focus:bg-white focus:border-blue-500 rounded-2xl px-4 py-3 text-sm font-bold text-gray-700 outline-none transition-all';
  var SEL = 'w-full bg-gray-50 border-2 border-transparent hover:border-blue-400 focus:border-blue-500 rounded-2xl px-4 py-3 pr-10 text-sm font-bold text-gray-700 appearance-none cursor-pointer transition-all';

  function handleKaydet() {
    var dateStr = ddmmyyyyToIso(tarih);
    onKaydet({
      kasaGiderId: kayit?.kasaGiderId,
      aciklama: ad,
      birimTutar: parseFloat(tutar) || 0,
      miktar: parseFloat(miktar) || 1,
      paraBirimi,
      odemeTipi: odemeTip,
      bankaAdi: (odemeTip && odemeTip.toUpperCase() !== 'NAKİT') ? banka : '',
      kurDegeri: kurDegeri,
      tarih: dateStr + 'T' + saat + ':00',
      personelHedefId: personelHedefId ? parseInt(personelHedefId) : null,
      giderGrubuId: giderGrubuId ? parseInt(giderGrubuId) : null,
    });
  }

  return (
    <ModalShell
      icon="💸"
      iconColor="from-red-500 to-rose-700"
      title={`Gider ${duzenleme ? 'Düzenle' : 'Ekle'}`}
      subtitle="Personel harcama ve masraf kaydı"
      onClose={onKapat}
      size="sm"
      zIndex="z-[80]"
      footer={
        <>
          {duzenleme && (
            <button onClick={function() { onSil(kayit.kasaGiderId); }} disabled={saving}
              className="px-6 py-3.5 bg-white border-2 border-red-100 text-red-600 hover:bg-red-600 hover:text-white hover:border-red-600 rounded-2xl text-[10px] font-black uppercase tracking-widest transition-all active:scale-95">
              SİL
            </button>
          )}
          <button onClick={onKapat}
            className="px-6 py-3.5 bg-white border-2 border-gray-100 rounded-2xl text-[10px] font-black uppercase tracking-widest text-gray-500 hover:bg-gray-100 transition-all active:scale-95">
            İPTAL
          </button>
          <button onClick={handleKaydet} disabled={saving}
            className="px-8 py-3.5 bg-red-600 hover:bg-red-700 disabled:opacity-50 text-white rounded-2xl text-[10px] font-black uppercase tracking-widest shadow-lg shadow-red-100 transition-all active:scale-95">
            {saving ? 'Kaydediliyor...' : duzenleme ? 'Güncellemeyi Kaydet' : 'Gideri Kaydet'}
          </button>
        </>
      }
    >
          {/* Personel */}
          <div>
            <label className="text-[10px] font-black text-gray-400 uppercase block mb-2 px-1 tracking-widest">Sorumlu Personel</label>
            <div className="relative group">
              <select value={personelHedefId} onChange={function(e) { setPersonelHedefId(e.target.value); }} className={SEL}>
                <option value="">— Personel Seçiniz —</option>
                {personelListe.map(function(p) { return <option key={p.personelId} value={p.personelId}>{p.adSoyad}</option>; })}
              </select>
              <span className="pointer-events-none absolute right-4 top-1/2 -translate-y-1/2 text-gray-400 text-xs transition-colors group-hover:text-blue-500">▼</span>
            </div>
          </div>
          {/* Gider Grubu (opsiyonel) */}
          {giderGruplari && giderGruplari.length > 0 && (
            <div>
              <label className="text-[10px] font-black text-gray-400 uppercase block mb-2 px-1 tracking-widest">Gider Grubu (Opsiyonel)</label>
              <div className="relative group">
                <select value={giderGrubuId} onChange={function(e) { setGiderGrubuId(e.target.value); }} className={SEL}>
                  <option value="">— Seçiniz —</option>
                  {giderGruplari.map(function(g) { return <option key={g.giderGrubuId} value={g.giderGrubuId}>{g.ad}</option>; })}
                </select>
                <span className="pointer-events-none absolute right-4 top-1/2 -translate-y-1/2 text-gray-400 text-xs transition-colors group-hover:text-blue-500">▼</span>
              </div>
            </div>
          )}
          {/* Açıklama */}
          <div>
            <label className="text-[10px] font-black text-gray-400 uppercase block mb-2 px-1 tracking-widest">Harcama Açıklaması</label>
            <input type="text" value={ad} onChange={function(e) { setAd(e.target.value); }} className={INP} placeholder="Örn: Haftalık Market Alışverişi" />
          </div>
          {/* Tutar & Para Birimi */}
          <div className="grid grid-cols-3 gap-3">
             <div className="col-span-2">
                <label className="text-[10px] font-black text-gray-400 uppercase block mb-2 px-1 tracking-widest">Birim Tutar</label>
                <input type="number" value={tutar} onChange={function(e) { setTutar(e.target.value); }} className={INP + ' text-right'} />
             </div>
             <div>
                <label className="text-[10px] font-black text-gray-400 uppercase block mb-2 px-1 tracking-widest">Birim</label>
                <div className="relative group">
                  <select value={paraBirimi} onChange={function(e) { setParaBirimi(e.target.value); }} className={SEL}>
                    {paraBirimiListesi.map(function(p) { return <option key={p}>{p}</option>; })}
                  </select>
                  <span className="pointer-events-none absolute right-4 top-1/2 -translate-y-1/2 text-gray-400 text-xs transition-colors group-hover:text-blue-500">▼</span>
                </div>
             </div>
          </div>
          {/* Miktar */}
          <div>
            <label className="text-[10px] font-black text-gray-400 uppercase block mb-2 px-1 tracking-widest">Adet / Miktar</label>
            <input type="number" min="1" value={miktar} onChange={function(e) { setMiktar(e.target.value); }} className={INP} />
          </div>
          {/* Ödeme tip & Banka */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <div>
                <label className="text-[10px] font-black text-gray-400 uppercase block mb-2 px-1 tracking-widest">Ödeme Yöntemi</label>
                <div className="relative group">
                  <select value={odemeTip} onChange={function(e) { setOdemeTip(e.target.value); }} className={SEL}>
                    {odemeTipListesi.map(function(o) { return <option key={o}>{o}</option>; })}
                  </select>
                  <span className="pointer-events-none absolute right-4 top-1/2 -translate-y-1/2 text-gray-400 text-xs transition-colors group-hover:text-blue-500">▼</span>
                </div>
              </div>
              {(odemeTip && odemeTip.toUpperCase() !== 'NAKİT') && (
                <div>
                  <label className="text-[10px] font-black text-gray-400 uppercase block mb-2 px-1 tracking-widest">İlgili Banka</label>
                  <div className="relative group">
                    <select value={banka} onChange={function(e) { setBanka(e.target.value); }} className={SEL}>
                      {bankaListesi.map(function(b) { return <option key={b}>{b}</option>; })}
                    </select>
                    <span className="pointer-events-none absolute right-4 top-1/2 -translate-y-1/2 text-gray-400 text-xs transition-colors group-hover:text-blue-500">▼</span>
                  </div>
                </div>
              )}
          </div>
          {/* Toplam Bilgi */}
          <div className="p-5 rounded-3xl bg-gray-50 border-2 border-gray-100 transition-all hover:bg-white hover:shadow-xl hover:shadow-gray-100 group/tot">
            <div className="flex justify-between items-center mb-1">
                <span className="text-[10px] font-black text-gray-400 uppercase tracking-widest">Genel Toplam</span>
                <span className="text-[10px] font-black text-red-500 bg-red-50 px-2 py-0.5 rounded-lg">HARCAMA</span>
            </div>
            <div className="flex items-baseline gap-2">
                <span className="text-2xl font-black text-gray-900 tracking-tighter">{toplam.toFixed(2)}</span>
                <span className="text-sm font-black text-gray-400">{paraBirimi}</span>
            </div>
            {paraBirimi !== 'TL' && paraBirimi !== 'TRY' && kurDegeri > 1 && (
              <p className="text-[10px] font-bold text-gray-400 mt-2 italic">
                ≈ {tlKarsıligi.toFixed(2)} TL <span className="opacity-60">(Kur: {kurDegeri.toFixed(4)})</span>
              </p>
            )}
          </div>
          {/* Tarih/Saat */}
          <div className="grid grid-cols-3 gap-3">
            <div className="col-span-2">
                <label className="text-[10px] font-black text-gray-400 uppercase block mb-2 px-1 tracking-widest">İşlem Tarihi</label>
                <DatePicker value={tarih} onChange={setTarih} />
            </div>
            <div>
                <label className="text-[10px] font-black text-gray-400 uppercase block mb-2 px-1 tracking-widest">Saat</label>
                <input type="time" value={saat} onChange={function(e) { setSaat(e.target.value); }}
                    className="w-full bg-gray-50 border-2 border-transparent focus:bg-white focus:border-blue-500 rounded-2xl px-3 py-3 text-sm font-bold text-gray-700 outline-none transition-all" />
            </div>
          </div>
    </ModalShell>
  );
}

// ── Sıralama İkonu ────────────────────────────────────────────────────────
function SortIcon({ field, sortKey, sortDir }) {
  if (sortKey !== field) return <span className="text-gray-300 ml-1 text-xs">⇅</span>;
  return <span className="text-blue-500 ml-1 text-xs">{sortDir === 'asc' ? '↑' : '↓'}</span>;
}

function MiniKart({ label, value, bgClass, textClass, icon }) {
  return (
    <div className={`relative overflow-hidden rounded-[1.5rem] p-4 transition-all duration-300 hover:-translate-y-1 hover:shadow-xl group ${bgClass} border border-white shadow-md flex flex-col justify-between`}>
      <div className="absolute -right-3 -bottom-3 text-6xl opacity-5 group-hover:scale-125 group-hover:-rotate-12 transition-transform duration-500">{icon}</div>
      <div className="flex items-start justify-between mb-1">
        <span className={`text-[9px] font-black uppercase tracking-[0.1em] ${textClass}`}>{label}</span>
        <span className="w-8 h-8 rounded-xl flex items-center justify-center text-lg bg-white shadow-sm font-emoji">{icon}</span>
      </div>
      <p className="text-[14px] mt-1 font-black text-gray-900 tracking-tight leading-none break-all">{value}</p>
    </div>
  );
}

function KolonFiltre({ value, onChange, placeholder }) {
  return (
    <input value={value} onChange={function(e) { onChange(e.target.value); }}
      placeholder={placeholder}
      className="w-full border border-gray-200 rounded-lg px-2 py-1.5 text-xs focus:outline-none focus:border-blue-400 bg-gray-50" />
  );
}

// ── Ana Bileşen ───────────────────────────────────────────────────────────
export default function PersonelGider() {
  var { odemeTipleri, paraBirimleri, bankalar, personeller, dovizKurlari, giderGruplari } = useKasa();

  var odemeTipListesi   = odemeTipleri.length > 0   ? odemeTipleri.map(function(o) { return o.ad; })               : ['BANKA HAVALE', 'NAKİT', 'KREDİ KARTI', 'ÇEK'];
  var paraBirimiListesi = paraBirimleri.length > 0  ? paraBirimleri.map(function(p) { return p.tcmbKod || p.ad; }) : ['TL', 'USD', 'EUR'];
  var bankaListesi      = bankalar.length > 0        ? bankalar.map(function(b) { return b.bankaAdi || b.ad; })     : ['Ziraat', 'Garanti', 'İş Bankası', 'Akbank', 'QNB'];

  var [basTarih,       setBasTarih]       = useState(ayBas());
  var [bitTarih,       setBitTarih]       = useState(bugunStr());
  var [personelSecId,  setPersonelSecId]  = useState('');
  var [aktifFiltre,    setAktifFiltre]    = useState({ bas: ayBas(), bit: bugunStr(), personelId: '' });

  var [satirlar,       setSatirlar]       = useState([]);
  var [toplamKayit,    setToplamKayit]    = useState(0);
  var [sayfa,          setSayfa]          = useState(1);
  var sayfaBoyutu = 50;

  var [loading,        setLoading]        = useState(false);
  var [error,          setError]          = useState(null);
  var [saving,         setSaving]         = useState(false);

  var [kTarih,    setKTarih]    = useState('');
  var [kAd,       setKAd]       = useState('');
  var [kPersonel, setKPersonel] = useState('');
  var [kOdemeTip, setKOdemeTip] = useState('');
  var [kTutar,    setKTutar]    = useState('');
  var [sortKey,   setSortKey]   = useState('tarih');
  var [sortDir,   setSortDir]   = useState('desc');
  var [modal,     setModal]     = useState(null);

  // Veri çek
  var fetchData = useCallback(function(filtre, pg) {
    setLoading(true);
    setError(null);
    var params = {
      baslangic: ddmmyyyyToIso(filtre.bas),
      bitis: ddmmyyyyToIso(filtre.bit),
      sayfa: pg,
      sayfaBoyutu: sayfaBoyutu,
    };
    if (filtre.personelId) params.personelHedefId = filtre.personelId;
    getPersonelGider(params).then(function(data) {
      setSatirlar((data && data.satirlar) ? data.satirlar : []);
      setToplamKayit((data && data.toplamKayit) ? data.toplamKayit : 0);
    }).catch(function() {
      setError('Veri alınamadı.');
    }).finally(function() {
      setLoading(false);
    });
  }, []);

  useEffect(function() {
    fetchData(aktifFiltre, sayfa);
  }, [aktifFiltre, sayfa, fetchData]);

  function handleBasChange(val) { setBasTarih(val); setBitTarih(clampBitis(val, bitTarih)); }
  function handleBitChange(val) { setBitTarih(clampBitis(basTarih, val)); }

  function filtrele() {
    var f = { bas: basTarih, bit: bitTarih, personelId: personelSecId };
    setAktifFiltre(f);
    setSayfa(1);
  }

  function temizle() {
    setBasTarih(ayBas()); setBitTarih(bugunStr()); setPersonelSecId('');
    setAktifFiltre({ bas: ayBas(), bit: bugunStr(), personelId: '' });
    setSayfa(1);
    setKTarih(''); setKAd(''); setKPersonel(''); setKOdemeTip(''); setKTutar('');
  }

  function handleSort(key) {
    if (sortKey === key) setSortDir(function(d) { return d === 'asc' ? 'desc' : 'asc'; });
    else { setSortKey(key); setSortDir('asc'); }
  }

  async function handleKaydet(data) {
    setSaving(true);
    try {
      if (data.kasaGiderId) {
        await updatePersonelGider(data.kasaGiderId, data);
      } else {
        await addPersonelGider(data);
      }
      setModal(null);
      fetchData(aktifFiltre, sayfa);
    } catch {
      setError('Kayıt işlemi başarısız.');
    } finally {
      setSaving(false);
    }
  }

  async function handleSil(id) {
    if (!(await confirmAsync())) return;
    setSaving(true);
    try {
      await deletePersonelGider(id);
      setModal(null);
      fetchData(aktifFiltre, sayfa);
    } catch {
      setError('Silme işlemi başarısız.');
    } finally {
      setSaving(false);
    }
  }

  // Client-side kolon filtresi + sıralama
  var goruntulenen = useMemo(function() {
    var liste = satirlar.filter(function(g) {
      var ts = (g.tarih || '') + ' ' + (g.saat || '');
      if (kTarih    && !ts.includes(kTarih)) return false;
      if (kAd       && !(g.aciklama || '').toLocaleLowerCase('tr-TR').includes(kAd.toLocaleLowerCase('tr-TR'))) return false;
      if (kPersonel && !(g.personelAdSoyad || '').toLocaleLowerCase('tr-TR').includes(kPersonel.toLocaleLowerCase('tr-TR'))) return false;
      if (kOdemeTip && !(g.odemeTipi || '').toLocaleLowerCase('tr-TR').includes(kOdemeTip.toLocaleLowerCase('tr-TR'))) return false;
      if (kTutar    && !String(g.birimTutar || '').includes(kTutar)) return false;
      return true;
    });
    return liste.slice().sort(function(a, b) {
      var av = sortKey === 'tutar' ? (a.birimTutar || 0)
             : sortKey === 'toplam' ? (a.toplamTutar || 0)
             : sortKey === 'miktar' ? (a.miktar || 0)
             : (a[sortKey] || '');
      var bv = sortKey === 'tutar' ? (b.birimTutar || 0)
             : sortKey === 'toplam' ? (b.toplamTutar || 0)
             : sortKey === 'miktar' ? (b.miktar || 0)
             : (b[sortKey] || '');
      if (av < bv) return sortDir === 'asc' ? -1 : 1;
      if (av > bv) return sortDir === 'asc' ? 1 : -1;
      return 0;
    });
  }, [satirlar, kTarih, kAd, kPersonel, kOdemeTip, kTutar, sortKey, sortDir]);

  // TL karşılığı toplam (kurDegeri çarpılır)
  var toplamTutar = goruntulenen.reduce(function(s, g) { return s + (g.toplamTutar || 0) * (g.kurDegeri || 1); }, 0);

  // Para birimlerine göre ayrı toplamlar (native değer, gösterim için)
  var toplamlarPB = goruntulenen.reduce(function(acc, g) {
    var pb = g.paraBirimi || 'TL';
    acc[pb] = (acc[pb] || 0) + (g.toplamTutar || 0);
    return acc;
  }, {});

  var perOzet = useMemo(function() {
    var map = {};
    goruntulenen.forEach(function(g) {
      var key = g.personelAdSoyad || '—';
      if (!map[key]) map[key] = 0;
      map[key] += (g.toplamTutar || 0) * (g.kurDegeri || 1);
    });
    return Object.entries(map).sort(function(a, b) { return b[1] - a[1]; });
  }, [goruntulenen]);

  var tipRenk = {
    'NAKİT':        'bg-green-100 text-green-700',
    'BANKA HAVALE': 'bg-blue-100 text-blue-700',
    'KREDİ KARTI':  'bg-purple-100 text-purple-700',
    'ÇEK':          'bg-orange-100 text-orange-700',
  };

  var toplamSayfa = Math.ceil(toplamKayit / sayfaBoyutu);

  function handleExcel() {
    var baslik = ['Tarih', 'Saat', 'Açıklama', 'Personel', 'Ödeme Tip', 'Miktar', 'Birim Tutar', 'Toplam', 'Para Birimi', 'Banka'];
    var satirlar = goruntulenen.map(function(g) {
      return [g.tarih, g.saat, g.aciklama, g.personelAdSoyad, g.odemeTipi, g.miktar,
              g.birimTutar, g.toplamTutar, g.paraBirimi, g.bankaAdi || ''];
    });
    downloadExcel('personel-gider-' + ddmmyyyyToIso(aktifFiltre.bas) + '_' + ddmmyyyyToIso(aktifFiltre.bit), 'Personel Giderleri', baslik, satirlar);
  }

  function handleYazdir() {
    var baslik = ['Tarih', 'Açıklama', 'Personel', 'Ödeme Tip', 'Miktar', 'Toplam', 'Para Birimi'];
    var satirlar = goruntulenen.map(function(g) {
      return [g.tarih + ' ' + g.saat, g.aciklama, g.personelAdSoyad, g.odemeTipi, g.miktar, g.toplamTutar, g.paraBirimi];
    });
    printTable('Personel Gider Raporu', baslik, satirlar, aktifFiltre.bas + ' – ' + aktifFiltre.bit + ' · ' + goruntulenen.length + ' kayıt');
  }

  var COLS = [
    { key: 'tarih',    label: 'Tarih/Saat' },
    { key: 'aciklama', label: 'Adı'        },
    { key: 'personelAdSoyad', label: 'Personel' },
    { key: 'odemeTipi', label: 'Ödeme tip' },
    { key: 'miktar',   label: 'Miktar'     },
    { key: 'tutar',    label: 'Tutar'      },
    { key: 'toplam',   label: 'Toplam', noSort: true },
  ];

  return (
    <div className="p-3 md:p-6 space-y-8 min-h-screen bg-gray-50/50" style={{ animation: 'fadeIn 0.3s ease-out' }}>

      <PageHeader
        icon="💸"
        iconColor="from-red-500 to-rose-700"
        iconShadow="shadow-red-200"
        title="Personel Giderleri"
        subtitle="Maaş, Avans & Masraf Takibi"
      >
        <div className="flex flex-wrap gap-4 items-center">
          <button onClick={() => setModal('ekle')} className="flex-1 md:flex-none flex items-center justify-center gap-3 bg-red-600 hover:bg-red-700 text-white font-black px-6 py-4 rounded-xl md:rounded-2xl shadow-xl shadow-red-200 transition-all text-[11px] uppercase tracking-widest hover:-translate-y-1 active:scale-95 whitespace-nowrap">
            <span className="text-lg">➕</span> YENİ GİDER
          </button>
          <div className="w-px h-10 bg-gray-200 mx-1 hidden md:block"></div>
          <button onClick={handleExcel} className="flex-[1] flex items-center justify-center gap-3 bg-white border-2 border-emerald-100 hover:border-emerald-500 hover:bg-emerald-50 text-emerald-700 font-black px-5 py-3 rounded-2xl shadow-lg shadow-emerald-50 transition-all text-[10px] uppercase tracking-widest hover:-translate-y-1 active:scale-95 whitespace-nowrap">
            <span>📊</span> EXCEL
          </button>
          <button onClick={handleYazdir} className="flex-[1] flex items-center justify-center gap-3 bg-white border-2 border-gray-100 hover:border-gray-800 hover:bg-gray-800 hover:text-white text-gray-700 font-black px-5 py-3 rounded-2xl shadow-lg shadow-gray-50 transition-all text-[10px] uppercase tracking-widest hover:-translate-y-1 active:scale-95 whitespace-nowrap">
            <span>🖨️</span> YAZDIR
          </button>
        </div>
      </PageHeader>

      {/* Hata */}
      {error && (
        <div className="bg-red-50 border border-red-200 text-red-700 rounded-xl px-4 py-3 text-sm font-medium">⚠️ {error}</div>
      )}

      {/* Akıllı Filtre Paneli */}
      <div className="bg-white rounded-[2.5rem] border border-gray-100 shadow-xl p-6 md:p-8 relative z-20">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4 items-end">
          <div>
            <label className="text-[10px] font-black text-gray-400 uppercase tracking-[0.2em] block mb-2.5 ml-1">Başlangıç</label>
            <DatePicker value={basTarih} onChange={handleBasChange} maxDate={bitTarih} />
          </div>
          <div>
            <label className="text-[10px] font-black text-gray-400 uppercase tracking-[0.2em] block mb-2.5 ml-1">Bitiş</label>
            <DatePicker value={bitTarih} onChange={handleBitChange} minDate={basTarih} />
          </div>
          <div>
            <label className="text-[10px] font-black text-gray-400 uppercase tracking-[0.2em] block mb-2.5 ml-1">Personel</label>
            <div className="relative">
              <select value={personelSecId} onChange={e => setPersonelSecId(e.target.value)} className="w-full bg-gray-50 border border-gray-200 rounded-2xl px-4 py-3 font-semibold text-sm text-gray-700 focus:outline-none focus:border-blue-400 appearance-none cursor-pointer">
                <option value="">— Hepsi —</option>
                {personeller.map(p => <option key={p.personelId} value={p.personelId}>{p.adSoyad}</option>)}
              </select>
            </div>
          </div>
          <div className="flex gap-2 h-[46px]">
            <button onClick={filtrele} disabled={loading} className="flex-[2] bg-blue-600 hover:bg-blue-700 text-white rounded-2xl font-black text-[10px] uppercase tracking-widest shadow-lg shadow-blue-200 transition-all active:scale-95 flex items-center justify-center">
              {loading ? 'YÜKLENİYOR...' : '🔍 FİLTRELE'}
            </button>
            <button onClick={temizle} className="flex-[1] bg-gray-50 border-2 border-gray-100 hover:bg-gray-100 text-gray-500 rounded-2xl font-black text-[10px] uppercase tracking-widest transition-all">Sıfırla</button>
          </div>
        </div>
      </div>

      {/* Özet + Dağılım */}
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 relative z-10">
        <div className="grid grid-cols-2 gap-4 lg:col-span-1">
          <MiniKart label="Toplam Kayıt" value={toplamKayit + ' adet'} bgClass="bg-gradient-to-br from-blue-50 to-indigo-50" textClass="text-blue-600" icon="📋" />
          <MiniKart label="Toplam Gider" value={Object.entries(toplamlarPB).length === 0 ? '0 TL' : Object.entries(toplamlarPB).map(e => e[1].toLocaleString('tr-TR', { minimumFractionDigits: 2 }) + ' ' + e[0]).join(' + ')} bgClass="bg-gradient-to-br from-red-50 to-rose-50" textClass="text-red-500" icon="💸" />
          <MiniKart label="Aktif Personel" value={perOzet.length + ' kişi'} bgClass="bg-gradient-to-br from-purple-50 to-fuchsia-50" textClass="text-purple-600" icon="👷" />
          <MiniKart label="Ort. Fiş / Gider" value={(goruntulenen.length ? Math.round(toplamTutar / goruntulenen.length) : 0).toLocaleString('tr-TR') + ' TL'} bgClass="bg-gradient-to-br from-amber-50 to-orange-50" textClass="text-orange-500" icon="📊" />
        </div>
        <div className="bg-white rounded-[2rem] border border-gray-100 shadow-xl p-8 lg:col-span-2 relative overflow-hidden">
          <h3 className="text-xs font-bold text-gray-600 uppercase tracking-wider mb-3">Personele Göre Gider Dağılımı</h3>
          {perOzet.length === 0
            ? <p className="text-sm text-gray-400 text-center py-4">{loading ? 'Yükleniyor...' : 'Kayıt bulunamadı'}</p>
            : (
              <div className="space-y-2">
                {perOzet.map(function(p) {
                  var yuzde = toplamTutar > 0 ? Math.round((p[1] / toplamTutar) * 100) : 0;
                  return (
                    <div key={p[0]}>
                      <div className="flex items-center justify-between mb-1">
                        <span className="text-xs font-medium text-gray-700">{p[0]}</span>
                        <span className="text-xs font-black text-gray-800">
                          {p[1].toLocaleString('tr-TR', { minimumFractionDigits: 2 })} TL
                          <span className="text-gray-400 font-normal"> ({yuzde}%)</span>
                        </span>
                      </div>
                      <div className="h-2 bg-gray-100 rounded-full overflow-hidden">
                        <div className="h-2 rounded-full bg-gradient-to-r from-blue-400 to-blue-600 transition-all duration-700" style={{ width: yuzde + '%' }}></div>
                      </div>
                    </div>
                  );
                })}
              </div>
            )
          }
        </div>
      </div>

      {/* Ödeme Tipi Dağılımı */}
      {goruntulenen.length > 0 && (function() {
        var odemeOzet = {};
        goruntulenen.forEach(function(g) {
          var k = g.odemeTipi || 'Diğer';
          if (!odemeOzet[k]) odemeOzet[k] = 0;
          odemeOzet[k] += (g.toplamTutar || 0) * (g.kurDegeri || 1);
        });
        var renkler = { 'BANKA HAVALE': 'bg-blue-500', 'NAKİT': 'bg-green-500', 'KREDİ KARTI': 'bg-purple-500', 'ÇEK': 'bg-orange-500' };
        var badgeRenk = { 'BANKA HAVALE': 'bg-blue-100 text-blue-700', 'NAKİT': 'bg-green-100 text-green-700', 'KREDİ KARTI': 'bg-purple-100 text-purple-700', 'ÇEK': 'bg-orange-100 text-orange-700' };
        return (
          <div className="bg-white rounded-[2rem] border border-gray-100 shadow-xl p-8 z-10 relative">
            <h3 className="text-[10px] font-black uppercase text-gray-400 tracking-[0.2em] mb-4">Ödeme Tipine Göre Dağılım</h3>
            <div className="flex gap-2 mb-3 flex-wrap">
              {Object.entries(odemeOzet).map(function(e) {
                return (
                  <span key={e[0]} className={'text-xs font-semibold px-3 py-1 rounded-full ' + (badgeRenk[e[0]] || 'bg-gray-100 text-gray-600')}>
                    {e[0]}: {e[1].toLocaleString('tr-TR', { minimumFractionDigits: 2 })} TL
                  </span>
                );
              })}
            </div>
            <div className="flex h-4 rounded-full overflow-hidden gap-0.5">
              {Object.entries(odemeOzet).map(function(e) {
                var pct = toplamTutar > 0 ? (e[1] / toplamTutar) * 100 : 0;
                return (
                  <div key={e[0]} title={e[0] + ': ' + pct.toFixed(1) + '%'}
                    className={'transition-all duration-700 ' + (renkler[e[0]] || 'bg-gray-400')}
                    style={{ width: pct + '%', minWidth: pct > 1 ? '4px' : '0' }}>
                  </div>
                );
              })}
            </div>
          </div>
        );
      })()}

      {/* Tablo – Mobil Kartlar */}
      <div className="md:hidden space-y-2">
        {loading ? (
          <LoadingSpinner fullPage text="Yükleniyor..." />
        ) : goruntulenen.length === 0 ? (
          <EmptyState icon="💸" text="Kayıt bulunamadı" />
        ) : goruntulenen.map(function(g) {
          return (
            <div key={g.kasaGiderId} onClick={() => setModal(g)} className="bg-white border border-gray-200 rounded-[1.5rem] p-4 cursor-pointer hover:border-blue-300 hover:shadow-lg transition-all">
              <div className="flex items-start justify-between mb-2">
                <div>
                  <p className="text-xs text-gray-400">{g.tarih} {g.saat}</p>
                  <p className="font-semibold text-gray-800 text-sm">{g.aciklama}</p>
                </div>
                <span className={'text-xs font-semibold px-2 py-0.5 rounded-full ' + (tipRenk[g.odemeTipi] || 'bg-gray-100 text-gray-600')}>
                  {g.odemeTipi}
                </span>
              </div>
              <div className="grid grid-cols-2 gap-x-4 gap-y-1 text-xs text-gray-600">
                <div className="col-span-2"><span className="text-gray-400">Personel: </span>{g.personelAdSoyad || '—'}</div>
                <div><span className="text-gray-400">Miktar: </span><strong>{g.miktar} adet</strong></div>
                <div><span className="text-gray-400">Birim: </span><strong>{(g.birimTutar||0).toLocaleString('tr-TR',{minimumFractionDigits:2})} {g.paraBirimi||'TL'}</strong></div>
                <div className="col-span-2"><span className="text-gray-400">Toplam: </span><strong className="text-red-600">{(g.toplamTutar||0).toLocaleString('tr-TR',{minimumFractionDigits:2})} {g.paraBirimi||'TL'}</strong></div>
              </div>
            </div>
          );
        })}
      </div>

      {/* Tablo – Masaüstü */}
      <div className="hidden md:block bg-white rounded-[2.5rem] border border-gray-100 shadow-xl overflow-hidden relative z-10">
        <div className="flex items-center justify-between px-8 py-5 border-b border-gray-50 bg-gray-50/30">
          <p className="text-sm font-semibold text-gray-700">
            Toplam <span className="text-blue-600 font-black">{toplamKayit}</span> kayıt —
            sayfa <span className="text-blue-600 font-black">{sayfa}</span> / {toplamSayfa || 1}
          </p>
          <div className="flex gap-2">
            <button onClick={function() { setSayfa(function(p) { return Math.max(1, p - 1); }); }}
              disabled={sayfa <= 1 || loading}
              className="text-xs px-3 py-1.5 border rounded-lg disabled:opacity-40 hover:bg-gray-50">Önceki</button>
            <button onClick={function() { setSayfa(function(p) { return Math.min(toplamSayfa, p + 1); }); }}
              disabled={sayfa >= toplamSayfa || loading}
              className="text-xs px-3 py-1.5 border rounded-lg disabled:opacity-40 hover:bg-gray-50">Sonraki</button>
          </div>
        </div>
        <div className="overflow-x-auto">
          <table className="w-full text-sm border-collapse">
            <thead>
              <tr className="bg-gray-50 border-b-2 border-gray-200">
                {COLS.map(function(col) {
                  return (
                    <th key={col.key}
                      onClick={function() { if (!col.noSort) handleSort(col.key); }}
                      className={'py-3 px-3 text-xs font-semibold text-gray-700 whitespace-nowrap select-none text-left ' + (col.noSort ? '' : 'cursor-pointer hover:bg-gray-100')}>
                      {col.label}
                      {!col.noSort && <SortIcon field={col.key} sortKey={sortKey} sortDir={sortDir} />}
                    </th>
                  );
                })}
              </tr>
              <tr className="bg-white border-b border-gray-100">
                <td className="px-2 py-1.5"><KolonFiltre value={kTarih}    onChange={setKTarih}    placeholder="Tarih/Saat" /></td>
                <td className="px-2 py-1.5"><KolonFiltre value={kAd}       onChange={setKAd}       placeholder="Ad" /></td>
                <td className="px-2 py-1.5"><KolonFiltre value={kPersonel} onChange={setKPersonel} placeholder="Personel" /></td>
                <td className="px-2 py-1.5"><KolonFiltre value={kOdemeTip} onChange={setKOdemeTip} placeholder="Ödeme tip" /></td>
                <td className="px-2 py-1.5"></td>
                <td className="px-2 py-1.5"><KolonFiltre value={kTutar}    onChange={setKTutar}    placeholder="Tutar" /></td>
                <td className="px-2 py-1.5"></td>
                <td className="px-2 py-1.5"></td>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <EmptyState as="td" colSpan={8} icon="⏳" text="Yükleniyor..." />
              ) : goruntulenen.length === 0 ? (
                <EmptyState as="td" colSpan={8} icon="💸" text="Kayıt bulunamadı" />
              ) : goruntulenen.map(function(g, idx) {
                return (
                  <tr key={g.kasaGiderId} onClick={() => setModal(g)}
                    className={'border-b border-gray-100 transition-colors cursor-pointer ' + (idx % 2 === 0 ? 'bg-white hover:bg-blue-50' : 'bg-gray-50/50 hover:bg-blue-50')}>
                    <td className="py-2.5 px-3 text-xs text-gray-700 whitespace-nowrap">{g.tarih} {g.saat}</td>
                    <td className="py-2.5 px-3 text-xs font-medium text-gray-800">{g.aciklama}</td>
                    <td className="py-2.5 px-3 text-xs text-gray-700">{g.personelAdSoyad}</td>
                    <td className="py-2.5 px-3">
                      <span className={'text-xs font-semibold px-2 py-0.5 rounded-full ' + (tipRenk[g.odemeTipi] || 'bg-gray-100 text-gray-600')}>
                        {g.odemeTipi}
                      </span>
                    </td>
                    <td className="py-2.5 px-3 text-xs text-gray-700">{g.miktar} adet</td>
                    <td className="py-2.5 px-3 text-xs font-semibold text-gray-800 text-right whitespace-nowrap">
                      {(g.birimTutar || 0).toLocaleString('tr-TR', { minimumFractionDigits: 2 })} {g.paraBirimi || 'TL'}
                    </td>
                    <td className="py-2.5 px-3 text-xs font-bold text-red-700 text-right whitespace-nowrap">
                      {(g.toplamTutar || 0).toLocaleString('tr-TR', { minimumFractionDigits: 2 })} {g.paraBirimi || 'TL'}
                    </td>

                  </tr>
                );
              })}
            </tbody>
            {goruntulenen.length > 0 && (
              <tfoot>
                <tr className="bg-gray-100 border-t-2 border-gray-300">
                  <td className="py-3 px-3 text-xs font-bold text-gray-600" colSpan={6}>TOPLAM</td>
                  <td className="py-3 px-3 text-xs font-black text-red-600 text-right whitespace-nowrap">
                    {Object.entries(toplamlarPB).map(function(e) {
                      return (
                        <div key={e[0]}>
                          {e[1].toLocaleString('tr-TR', { minimumFractionDigits: 2 })} {e[0]}
                        </div>
                      );
                    })}
                  </td>
                  <td className="py-3 px-3"></td>
                </tr>
              </tfoot>
            )}
          </table>
        </div>
      </div>

      {modal && (
        <GiderModal
          kayit={modal === 'ekle' ? null : modal}
          personelListe={personeller}
          giderGruplari={giderGruplari}
          odemeTipListesi={odemeTipListesi}
          paraBirimiListesi={paraBirimiListesi}
          bankaListesi={bankaListesi}
          dovizKurlari={dovizKurlari}
          onKaydet={handleKaydet}
          onSil={handleSil}
          onKapat={function() { setModal(null); }}
          saving={saving}
        />
      )}

      <UsageInfo
        color="red"
        description="Personel Gider modülü, çalışanlara verilen maaş, avans, harcırah veya mesai ödemelerinin tamamının toplandığı alandır. Bu rapor, kasa çıkışlarınızı doğrulamanızı sağlar."
        scenarios={[
          { title: "Personel Başına Ödenen Toplam Tutar", content: "Ay sonunda maaş günleri için tabloyu listelediğinizde 'Dağılım' grafiği üzerinden o ay en çok hangi personele nakit çıkışı veya avans sağlandığını görsel olarak analiz edebilirsiniz." },
          { title: "Kasa vs Banka Transfer Dengesi", content: "Ödeme tipine göre dağılım sayesinde, banka kasanızdan (Havale/EFT) mı yoksa fiziksel kasanızdan (Nakit) mı daha çok para sirkülasyonu olduğunu görebilirsiniz." },
          { title: "Hızlı Düzenleme İşlemleri", content: "Yanlış bir gider tutarı mı var? Tablodaki (veya mobilde karttaki) herhangi bir harcama hareketinin üzerine tıklayarak anında 'Gider Modalını' açıp düzenleme/silme işlemi yapabilirsiniz." }
        ]}
      />
      <style>{`
        @keyframes fadeIn { from { opacity: 0; transform: translateY(8px); } to { opacity: 1; transform: translateY(0); } }
      `}</style>
    </div>
  );
}
